import React, { Fragment, useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import TituloConIcono from 'components/tituloConIcono';
import { TablaPersonalizada } from 'components';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import { functions } from 'constantes/functions';
import { obtenerRegistrosPorURL, setearDatosAlStore } from 'store/actions/customAction';
import { useDispatch, useSelector } from 'react-redux';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import FormularioDeInscripcion from './FormularioDeInscripcion';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import { NoAutorizado } from 'commons';
import DetalleDelRegistro from './detalleDelRegistro';
import { estadosSolicitudEmpresa, tipoDeClasificaionRadio, tiposDeMediosExterior, tiposMediosPorID } from 'constantes/globalsStates';
import { Chip, IconButton } from '@mui/material';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';
import GetAppIcon from '@mui/icons-material/GetApp';
import { solicitar_datos } from 'servicios/Api';

const RegistroDeMediosComunicacion = () => {
  const dispatch = useDispatch();
  const { currentUser } = useSelector(({ security }) => security);
  const { datosDeEmpresa, personaIndividual } = useSelector(({ medio }) => medio);
  const [registroDeMediosDeComunicacion] = useState("formularioDeRegistroDeMediosDeComunicacion")
  const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, })
  const [cargandoSolicitud, setCargandoSolicitud] = useState(false),
    [datosGeneralesDeSolicitud, setDatosGeneralesDeSolicitud] = useState({}),
    [abrirNuevaSolicitud, setAbrirNuevaSolicitud] = useState(false),
    [validarDatos, setValidarDatos] = useState({ checkearAutorizacion: false, autorizado: true, cargando: true }),
    [abrirDetalleDeSolicitud, setAbrirDetalleDeSolicitud] = useState(false);
  const [header] = useState([
    { title: 'No. solicitud', field: 'id' },
    { title: 'Empresa', field: 'nombreEmpresa' },
    { title: 'Nit del solicitante', field: 'nitSolicitante' },
    { title: 'Nombre del solicitante', field: 'nombreSolicitante' },
    { title: 'Fecha de creación', field: 'fechaCreacion', render: (rowData) => functions.FormatearFecha(rowData.fechaCreacion || "") },

    {
      title: 'Estado de solicitud', field: 'idEstadoDeSolicitudEmpresa', filtering: false,
      render: rowData => <div style={{ minWidth: '100px' }}>
        {
          (<Chip label={rowData?.idEstadoDeSolicitudEmpresa ? estadosSolicitudEmpresa[rowData?.idEstadoDeSolicitudEmpresa]?.label || "" : 'Sin estado'} color="primary" />)
        }
      </div>
    },
    {
      title: 'Acciones', field: 'accion',
      render: rowData => <div style={{ minWidth: '100px' }}>
        {
          (<div>
            <TooltipPersonalizado title="Visualizar detalle del registro de medios" handleFunction={() => mostrarDetalleDeSolicitud(rowData)} icon="visibility" fontSize={30} />
            {Number(rowData?.idEstadoDeSolicitudEmpresa || 0) === 6 ? (
              <TooltipPersonalizado title="Editar datos del registro de medios" handleFunction={() => editarDatosDeSolicitud(rowData)} icon="edit" fontSize={30} />
            ) : null}
          </div>)
        }
      </div>
    },
  ]);

  useEffect(() => {
    obtenerRegistros();
  }, [])

  const obtenerRegistros = async () => {
    try {
      setValidarDatos({ checkearAutorizacion: true, autorizado: false, cargando: true });

      const hasPermission = await ServiciosDelAPI.seguridadDeSSOUsuario.hasPermission(registroDeMediosDeComunicacion, 'listar');
      if (hasPermission.error) return setValidarDatos({ checkearAutorizacion: false, autorizado: false, cargando: false });

      ServiciosDelAPI[registroDeMediosDeComunicacion].iniciarMetodoDeBusqueda.clear();
      ServiciosDelAPI[registroDeMediosDeComunicacion].iniciarMetodoDeOrden.clear();
      // ServiciosDelAPI[registroDeMediosDeComunicacion].iniciarMetodoDeOrden.addAsc("idEstadoDeSolicitudEmpresa");
      ServiciosDelAPI[registroDeMediosDeComunicacion].iniciarMetodoDeOrden.addDesc("id");
      setValidarDatos({ checkearAutorizacion: false, autorizado: true, cargando: false });
    } catch (exception) {
      alertaPersonalizadaSwal(exception.message || 'No encontramos información. Intente recargar de nuevo.')
      setValidarDatos({ checkearAutorizacion: false, autorizado: true, cargando: false });
    }
  }

  const obtenerPrimerValorConContenido = (...valores) => {
    for (const valor of valores) {
      if (valor === null || valor === undefined) continue;
      const texto = String(valor).trim();
      if (texto) return texto;
    }
    return "";
  };

  const obtenerCodigoUsuario = () => {
    return obtenerPrimerValorConContenido(
      currentUser?.code,
      currentUser?.codigo,
      currentUser?.username,
      currentUser?.email
    );
  };

  const precargarDatosEmpresaDesdeUsuario = async () => {
    let respuesta = null;
    try {
      respuesta = await solicitar_datos({
        url: '/sso-externo/usuarios/mi/detalle',
        method: 'GET'
      });
    } catch (e) {
      return;
    }

    if (!respuesta) return;

    const detalleUsuario = respuesta;

    if (!detalleUsuario) return;

    const nombreEmpresaMapeado = obtenerPrimerValorConContenido(
      detalleUsuario?.nombreEmpresa,
      detalleUsuario?.razonSocial,
      detalleUsuario?.nombreComercial,
      detalleUsuario?.empresa
    );
    const nitMapeado = obtenerPrimerValorConContenido(
      detalleUsuario?.nit,
      detalleUsuario?.nitEmpresa,
      detalleUsuario?.nitSolicitante
    );

    if (nombreEmpresaMapeado) {
      await dispatch(setearDatosAlStore({
        dispatchAction: nombreDeAcciones.SET_DATA_COMPANY,
        data: {
          company: {
            ...datosDeEmpresa,
            nombreEmpresa: nombreEmpresaMapeado
          },
          activeStep: 0,
          numberStep: 1
        }
      }));
    }

    if (nitMapeado) {
      await dispatch(setearDatosAlStore({
        dispatchAction: nombreDeAcciones.SET_DATA_PERSON_ISSUING_THE_INVOICE,
        data: {
          personaIndividual: {
            ...personaIndividual,
            nit: nitMapeado
          },
          activeStep: 0,
          numberStep: 1
        }
      }));
    }
  };

  const agregarRegistro = async () => {
    await precargarDatosEmpresaDesdeUsuario();
    setAbrirNuevaSolicitud(true);
  }

  const cerrarModalNuevaSolicitud = () => {
    setAbrirNuevaSolicitud(false)
  };

  const mostrarDetalleDeSolicitud = async (elemento) => {
    setCargandoSolicitud(true);
    let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: registroDeMediosDeComunicacion, saveInStore: false, nombreDelMetodo: "listar/registros", parametro: elemento?.id }));

    setCargandoSolicitud(false);

    if (respuesta?.error) return alertaPersonalizadaSwal(`${respuesta.error?.message || "No se pudo obtener la información del registro"}`);

    if (respuesta?.data?.length === 0) return alertaPersonalizadaSwal("No existen datos para mostrar");

    setDatosGeneralesDeSolicitud(respuesta.data)
    setAbrirDetalleDeSolicitud(true)
  }

  const editarDatosDeSolicitud = async (elemento) => {
    setCargandoSolicitud(true);
    let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: registroDeMediosDeComunicacion, saveInStore: false, nombreDelMetodo: "listar/registros", parametro: elemento?.id }));

    setCargandoSolicitud(false);

    if (respuesta?.error) return alertaPersonalizadaSwal(`${respuesta.error?.message || "No se pudo obtener la información del registro"}`);

    if (respuesta?.data?.length === 0) return alertaPersonalizadaSwal("No existen datos para mostrar");

    const normalizarFechaDesdeBackend = (valor) => {
      if (!valor) return "";

      if (valor instanceof Date && !Number.isNaN(valor.getTime())) {
        return new Date(valor.getFullYear(), valor.getMonth(), valor.getDate());
      }

      if (typeof valor === 'string') {
        const texto = valor.trim();
        const iso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (iso) {
          const y = Number(iso[1]);
          const m = Number(iso[2]) - 1;
          const d = Number(iso[3]);
          return new Date(y, m, d);
        }

        const local = texto.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
        if (local) {
          const d = Number(local[1]);
          const m = Number(local[2]) - 1;
          const y = Number(local[3]);
          return new Date(y, m, d);
        }
      }

      const parsed = new Date(valor);
      if (!Number.isNaN(parsed.getTime())) {
        return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
      }

      return "";
    };

    const normalizarPdfBase64 = (valor) => {
      if (!valor) return null;
      const contenido = String(valor).trim();
      if (!contenido) return null;
      return contenido.startsWith('data:application/pdf;base64,') ? contenido : `data:application/pdf;base64,${contenido}`;
    };

    // DATOS DE LA EMPRESA
    const { nombreEmpresa, direccion, notificacion, correoElectronico, telefono, telefono1, nombreEnlaceMedio, correoEnlaceMedio, telEnlaceMedio, patente, patenteRegistro, patenteFolio, patenteLibro, numeroRegistroTimbre, fechaInscripcionTimbre, fechaVigenciaHastaTimbre, solicitudPersonaJuridica, solicitudPersona, esArrendatario, fechaInicioArrenda, fechaFinArrenda, propolitica } = respuesta?.data

    const datosDeEmpresa = {
      nombreEmpresa,
      direccionEmpresa: direccion,
      direccionNotificaciones: notificacion,
      correoElectronico,
      telefono,
      telefono2: telefono1 || "",
      nombreEnlace: nombreEnlaceMedio,
      correoElectronicoMedio: correoEnlaceMedio,
      telefonoMedio: telEnlaceMedio,
      patente,
      registro: patenteRegistro,
      folio: patenteFolio,
      libro: patenteLibro,
      archivoPatenteComercio: "",
      declaracionJurada: "",
      NumeroRegistro: numeroRegistroTimbre || "",
      FechaInscripcion: normalizarFechaDesdeBackend(fechaInscripcionTimbre) || "",
      FechaVigencia: normalizarFechaDesdeBackend(fechaVigenciaHastaTimbre) || "",
      archivoTimbre: "",
      solvenciaTimbre: "",
      tipoPropietario: solicitudPersonaJuridica?.length > 0 ? '0' : '1',
    };

    let listadoPersonaIndividual = [];
    if (solicitudPersona?.length > 0) {
      listadoPersonaIndividual = solicitudPersona.map(({ cui, nombre, docDpi, pdfDpi, dpi }) => ({
        id: cui,
        cui,
        cuiNuevo: cui,
        nombreCompleto: nombre,
        pdfDpi: normalizarPdfBase64(docDpi || pdfDpi || dpi)
      }))
    }

    let personaLegal = {};
    if (solicitudPersonaJuridica?.length > 0) {
      const { cuiRepresentante, nombreComercial, razonSocial, notarioConstitucion, nroConstitucion, nroInscripcionEscriConst, folioConstitucion, libroConstitucion, nombreRepLegal, nroFolioReplegal, nroLibroRepLegal, nroRegRepLegal, fechaEscrituraConst, fechaVigenciaRepLegal } = solicitudPersonaJuridica[0]
      personaLegal = {
        razonSocial,
        nombreComercial,
        numeroConstitucion: nroConstitucion,
        fechaEscritura: normalizarFechaDesdeBackend(fechaEscrituraConst) || "",
        nombreNotario: notarioConstitucion,
        numeroInscripcion: nroInscripcionEscriConst,
        folio: folioConstitucion,
        libro: libroConstitucion,
        constitucionSociedad: "",
        cuiRepresentanteLegal: cuiRepresentante,
        nombreRepresentante: nombreRepLegal,
        fechaVigencia: normalizarFechaDesdeBackend(fechaVigenciaRepLegal) || "",
        folioRepresentante: nroFolioReplegal,
        libroRepresentante: nroLibroRepLegal,
        registroRepresentante: nroRegRepLegal,
        certificacionRegistroMercantil: "",
      }
    }

    const arrendatario = {
      esArrendatario,
      fechaInicioArrendamiento: normalizarFechaDesdeBackend(fechaInicioArrenda),
      fechaFinArrendamiento: normalizarFechaDesdeBackend(fechaFinArrenda),
      proPolitica: propolitica,
      pdfContratoArrenda: ""
    }

    const { nitSolicitante, nombreSolicitante, rgaeRegistro, rgaeResolucion, rgaeFolio, solicitudTV, solicitudRadio, solicitudEscrito, solicitudExteriores } = respuesta?.data;

    const personaIndividual = {
      nit: nitSolicitante,
      nombreEmiteFactura: nombreSolicitante,
      constanciaRTU: "",
      noRegistro: rgaeRegistro,
      numeroResolucion: rgaeResolucion,
      folioRGAE: rgaeFolio,
      constanciaRGAE: "",
    };

    let listadoDeCaracteristicas = [];

    if (solicitudTV?.length > 0) {
      const { /*numeroOrdenUncosu, numeroRegistroUncosu,*/numeroCertificacionUncosu, fechaVigenciaHastaUncosu, numeroCertificacionSit,/* numeroOrdenSit, numeroRegistroSit,*/ fechaVigenciaHastaSit, licOpSatelital, numeroOrdenSatel, numeroRegistroSatel, fechaVigenciaSatelital, tipoDeTelevision, idTipoDeTelevision, id } = solicitudTV[0];

      const solicitudEmpresaTelevisionRequest = {
        // TV POR CABLE
        "idTipoDeTelevision": idTipoDeTelevision || 0,

        "numeroCertificacionUncosu": Number(idTipoDeTelevision) === 1 ? numeroCertificacionUncosu || "" : "",
        //"numeroOrdenUncosu": Number(idTipoDeTelevision) === 1 ? numeroOrdenUncosu || "" : "",
        //"numeroRegistroUncosu": Number(idTipoDeTelevision) === 1 ? numeroRegistroUncosu || "" : "",
        "fechaVigenciaHastaUncosu": Number(idTipoDeTelevision) === 1 ? normalizarFechaDesdeBackend(fechaVigenciaHastaUncosu) || "" : "",
        "pdfConstanciaUncosu": "",

        // TV ABIERTA
        "numeroCertificacionSit": Number(idTipoDeTelevision) === 2 ? numeroCertificacionSit || "" : "",
        //"numeroOrdenSit": Number(idTipoDeTelevision) === 2 ? numeroOrdenSit || "" : "",
        //"numeroRegistroSit": Number(idTipoDeTelevision) === 2 ? numeroRegistroSit || "" : "",
        "fechaVigenciaHastaSit": Number(idTipoDeTelevision) === 2 ? normalizarFechaDesdeBackend(fechaVigenciaHastaSit) || "" : "",
        "pdfConstanciaSit": "",

        // TV SATELITAL
        "licenciaDeOperacionDeFacilidades": licOpSatelital,
        "numeroDeOrdenSatelital": Number(idTipoDeTelevision) === 3 ? numeroOrdenSatel || "" : "",
        "numeroDeRegistroSatelital": Number(idTipoDeTelevision) === 3 ? numeroRegistroSatel || "" : "",
        "fechaVigenciaHastaSatelital": Number(idTipoDeTelevision) === 3 ? normalizarFechaDesdeBackend(fechaVigenciaSatelital) || "" : "",
        "pdfConstanciaLicenciaSatelital": "",
      }

      listadoDeCaracteristicas.push({
        empresa: nombreEmpresa,
        tipoDeMedio: tiposMediosPorID[1],
        tipoOClasificacionDelMedio: {
          id: tipoDeTelevision?.id || "",
          name: tipoDeTelevision?.descripcion || ""
        },
        solicitudEmpresaTelevisionRequest,
        id,
      })
    }

    if (solicitudRadio?.length > 0) {

      const { /*numeroOrdenSit, numeroRegistroSit,*/ numeroCertificacionSit, fechaVigenciaSit, radioAM, radioFM, id } = solicitudRadio[0];

      const solicitudEmpresaRadioRequest = {
        radioAM,
        radioFM,
        "numeroDeCertificacionSit": numeroCertificacionSit || "",
        //"numeroDeOrdenSit": numeroOrdenSit || "",
        //"numeroDeRegistroSit": numeroRegistroSit || "",
        "fechaVigenciaHastaSit": normalizarFechaDesdeBackend(fechaVigenciaSit) || "",
        "pdfConstanciaSit": "",
      }

      let tipoDeRadioSolicitud = 0

      if (radioAM && radioAM) tipoDeRadioSolicitud = 10
      else if (radioAM && !radioFM) tipoDeRadioSolicitud = 4
      else tipoDeRadioSolicitud = 5

      listadoDeCaracteristicas.push({
        empresa: nombreEmpresa,
        tipoDeMedio: tiposMediosPorID[2],
        tipoOClasificacionDelMedio: tipoDeClasificaionRadio[tipoDeRadioSolicitud],
        solicitudEmpresaRadioRequest,
        id,
      })
    }

    if (solicitudEscrito?.length > 0) {

      const { tipoDeCirculacionDeMedioEscrito, tipoDeMedioEscrito, enlaceWeb, id } = solicitudEscrito[0];

      const solicitudEmpresaEscritosRequest = {
        "tipoDeMedioEscrito": tipoDeMedioEscrito?.id || "",
        "idTipoCirculacionDeMedio": Number(tipoDeCirculacionDeMedioEscrito?.id) || "",
        "tieneSitioWeb": enlaceWeb != "" ? false : true,
        "sitioWeb": enlaceWeb || "",
      }

      listadoDeCaracteristicas.push({
        empresa: nombreEmpresa,
        tipoDeMedio: tiposMediosPorID[3],
        tipoOClasificacionDelMedio: {
          id: tipoDeMedioEscrito?.id || "",
          name: tipoDeMedioEscrito?.descripcion || ""
        },
        id,
        solicitudEmpresaEscritosRequest,
      })
    }

    if (solicitudExteriores?.length > 0) {

      const { esvalla, espantalla, autorizacionMunicipal, tipoExterior, idTipoExterior, id } = solicitudExteriores[0];
      const tipoExteriorNormalizado = Number(tipoExterior || idTipoExterior || (espantalla ? 4 : esvalla ? 5 : 0));

      const solicitudEmpresaExteriorRequest = {
        esPantalla: tipoExteriorNormalizado === 4,
        esValla: [4, 5, 6].includes(tipoExteriorNormalizado),
        tieneAutorizacionMunicipal: autorizacionMunicipal,
        tipoExterior: tipoExteriorNormalizado || 5
      }

      listadoDeCaracteristicas.push({
        empresa: nombreEmpresa,
        tipoDeMedio: tiposMediosPorID[4],
        tipoOClasificacionDelMedio: tiposDeMediosExterior[tipoExteriorNormalizado] || tiposDeMediosExterior[5],
        solicitudEmpresaExteriorRequest,
        id,
      })
    }

    dispatch(setearDatosAlStore({
      dispatchAction: nombreDeAcciones.SETEAR_ALL_REDUCER,
      data: {
        datosDeEmpresa,
        listadoPersonaIndividual,
        personaLegal,
        arrendatario,
        personaIndividual,
        listadoDeCaracteristicasDelMedio: listadoDeCaracteristicas,
        idSolicitud: respuesta?.data?.id
      }
    }));

    setAbrirNuevaSolicitud(true)
  }

  const cerarModalDetalleDeSolicitud = () => setAbrirDetalleDeSolicitud(false)

  const handClose = (_, reason) => {
    if (reason === 'clickaway') { return }
    changeDataResponse('error', '', false)
  };

  const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => setResponseData({ tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta, })

  const { errorType, messageType, openResponse } = responseData;
  const { checkearAutorizacion, autorizado, cargando } = validarDatos;

  if (checkearAutorizacion) return <IndicadorDeCarga open={cargando} />
  if (!autorizado && !cargando) { return <NoAutorizado /> }

  return (
    <Fragment>
      {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : ''}
      <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose} />
      <TituloConIcono title={"Registro de medios de comunicación"} icon={""} mostrarBotones={false} mostrarTiempo={false} />
      <Card>
        <CardContent>
          <TablaPersonalizada
            service={ServiciosDelAPI[registroDeMediosDeComunicacion]}
            data={[]}
            title={"Listado de registro de medios de comunicación"}
            header={header}
            refreshList={obtenerRegistros}
            addRegister={agregarRegistro}
	    disableAddRegister={true}
            pageSize={10}
            nombreToolTip={"Periodo de inscripción finalizado"}
          />
        </CardContent>
        {abrirNuevaSolicitud && (
          <FormularioDeInscripcion
            openFullScreenDialog={abrirNuevaSolicitud}
            handleClose={cerrarModalNuevaSolicitud}
            title={"Formulario de inscripción"}
            obtenerRegistros={obtenerRegistros}
          />
        )}
        {abrirDetalleDeSolicitud && (
          <DetalleDelRegistro
            openFullScreenDialog={abrirDetalleDeSolicitud}
            handleClose={cerarModalDetalleDeSolicitud}
            title={'Detalle del registro ingresado'}
            datosGeneralesDeSolicitud={datosGeneralesDeSolicitud}
          />
        )}
      </Card>
    </Fragment>
  );
}

export default RegistroDeMediosComunicacion;
